import React, { useState } from 'react';
import { FormattedMessage, useIntl } from '../../util/reactIntl';
import { Button } from '../../components';
import css from './SingleBlogPage.module.css';
import element1 from '../../assets/blog-shape1.png';
import element2 from '../../assets/blog-shape2.png';
import { STATUS } from '../../helpers/enums';
import { subscribeToNewsletter } from '../../components/Footer/Footer.duck';
import { useDispatch } from 'react-redux';
import { Flip, toast } from 'react-toastify';

function SectionHero(props) {
  const { title } = props;
  const intl = useIntl();
  const dispatch = useDispatch();
  const [inProgress, setInProgress] = useState(false);

  const successMessage = intl.formatMessage({ id: 'Footer.successMessage' });
  const errorMessage = intl.formatMessage({ id: 'Footer.errorMessage' });

  const toasterProps = {
    position: 'top-right',
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'colored',
    transition: Flip,
  };

  const onTriggerToast = type => {
    const [message, toastType] =
      type === STATUS.SUCCESS ? [successMessage, toast.success] : [errorMessage, toast.error];

    toastType(message, toasterProps);
  };

  const [email, setEmail] = useState('');

  const handleSubmit = async event => {
    event.preventDefault();
    setInProgress(true);
    try {
      const subscription = await dispatch(subscribeToNewsletter({ email }));
      onTriggerToast(subscription?.status);
      setEmail('');
    } catch {
      onTriggerToast(STATUS.ERROR);
    } finally {
      setInProgress(false);
    }
  };

  const handleEmailChange = event => {
    setEmail(event.target.value);
  };

  return (
    <div className={css.heroContainer}>
      <span className={css.shape1}>
        <img src={element1} alt="element" />
      </span>
      <span className={css.shape2}>
        <img src={element2} alt="element" />
      </span>
    </div>
  );
}

export default SectionHero;
